import React, { useCallback, useRef } from 'react';
import { CustomTitle } from '@meitu/saas-ui/es/title';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { BrushTagType } from '../config';
import SelectColor from './components/select-color';
import SelectPoint from './components/select-point';
import SelectStyle from './components/select-style';
import SelectWidth from './components/select-width';
import { customConfig } from './custom-config';
import DragPopover from './drag-popover';

const RenderLinePopover: React.FC<{
    type: BrushTagType;
    onClose?: () => void;
    onComplete?: (type: BrushTagType) => void;
}> = React.memo(({ type, onClose, onComplete }) => {
    const { $t } = useLocaleStore();

    const onCompleteHandle = useCallback(() => {
        onComplete?.(type);
    }, []);

    const draggleRef = useRef<HTMLDivElement>(null);

    return (
        <DragPopover draggleRef={draggleRef}>
            <div ref={draggleRef} className="c-brush-collapse__popover">
                <div className="c-brush-collapse__popover-title">
                    <CustomTitle
                        leftNode={<div className="left">{$t((v) => v.collapse.brushCollapse.defineLinePen)}</div>}
                        rightNode={
                            <div
                                className="right"
                                onClick={() => {
                                    onClose?.();
                                }}
                            >
                                <IconFont name="CrossBlack" fontSize={12} color="var(--content-system-secondary)" />
                            </div>
                        }
                    />
                </div>
                <div className="c-brush-collapse__popover-color">
                    <LabelAction title={$t((v) => v.panel.brushPanel.color)} align={true}>
                        <SelectColor
                            defaultVal={customConfig.line.color}
                            dataSource={customConfig.line}
                            onComplete={onCompleteHandle}
                        />
                    </LabelAction>
                </div>
                <SelectStyle
                    defaultDasharray={customConfig.line.dasharray}
                    defaultLinecap={customConfig.line.linecap}
                    dataSource={customConfig.line}
                    onComplete={onCompleteHandle}
                />
                <SelectWidth
                    defaultVal={customConfig.line.width}
                    dataSource={customConfig.line}
                    onComplete={onCompleteHandle}
                    maxValue={100}
                    minValue={1}
                />
                <SelectPoint
                    defaultStartPoint={customConfig.line.startPoint}
                    defaultEndPoint={customConfig.line.endPoint}
                    dataSource={customConfig.line}
                    onComplete={onCompleteHandle}
                />
            </div>
        </DragPopover>
    );
});

export default RenderLinePopover;
